import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { allowedTableCellPropTypes } from '../utils/allowedPropTypes';
import Definition from './_Definition';

const DefinitionList = ({ listData }) => (
  <dl>
    {listData.map(listItemData => (
      <div className='definition-wrapper' key={uuidv4()}>
        <dt>
          <div className='overflow-limiter'>
            {listItemData.columnHeadingContent}
          </div>
        </dt>
        <Definition listItemData={listItemData} />
      </div>
    ))}
  </dl>
);

DefinitionList.propTypes = {
  listData: PropTypes.arrayOf(
    PropTypes.shape(allowedTableCellPropTypes)
  ).isRequired
};

export default DefinitionList;